
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  padding: 0 24px;
  flex: 1;
`;

export const Footer = styled.View`
  padding: 0 24px;
 
`;
